export default __webpack_public_path__ + "static/media/equip-about.70671854.png";